module.exports = __webpack_public_path__ + "黄子权-0a77cda0.png";